import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './App.css';

import CardComponent from './components/CardComponent';
import Carousel from "./components/CarouselComponent";
import NavbarComponent from './components/NavbarComponent';

import About from './pages/About';
import Contact from './pages/Contact'
import Footer from './pages/Footer';
import Plans from "./pages/Plans";

import { SiWhatsapp } from 'react-icons/si';
// import WahRunner from "./components/WAH";

function whatsapp() {
    const url = "https://wa.me/+56948999358?text=Hola%20quiero%20agendar%20una%20clase%20de%20prueba.";
    window.open(url, '_blank');
}

function App() {
    return (
        <main className='App'>
            <NavbarComponent />
            <section id="inicio">
                <Carousel />
            </section>
            <section id="planes">
                <Plans />
            </section>
            <section id="nosotros">
                <h2 className="h2-title">NUESTRA HISTORIA</h2>
                <article id="nosotros-contenido">
                    <About />
                    <CardComponent />
                </article>
            </section>
            <section id="contacto">
                <Contact />
            </section>
            <Footer />
            <button aria-label="Enviar mensaje a la academia por Whatsapp" className="whatsapp" onClick={whatsapp}>
                <SiWhatsapp />
            </button>
            {/* <WahRunner></WahRunner> */}
        </main>
    );
}

export default App;
